/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceOptionsUpdateRequest
 */
export interface WorkspaceOptionsUpdateRequest {
    /**
     * These are Persona IDs.
     * @type {Array<string>}
     * @memberof WorkspaceOptionsUpdateRequest
     */
    defaultAssignees: Array<string>;
    /**
     * These are IDs of WorkspaceMembers.
     * @type {Array<string>}
     * @memberof WorkspaceOptionsUpdateRequest
     */
    defaultEmailNotification: Array<string>;
    /**
     * After how many minutes to send an email notification about a new chat message (-1 to disable).
     * @type {number}
     * @memberof WorkspaceOptionsUpdateRequest
     */
    defaultEmailDelay: number;
    /**
     * The default inactivity limit in minutes (-1 to disable).
     * @type {number}
     * @memberof WorkspaceOptionsUpdateRequest
     */
    defaultInactivityLimit: number;
    /**
     * Whether to send an email to the client about unread messages.
     * @type {boolean}
     * @memberof WorkspaceOptionsUpdateRequest
     */
    emailClientsAboutUnreadMessages: boolean;
}

/**
 * Check if a given object implements the WorkspaceOptionsUpdateRequest interface.
 */
export function instanceOfWorkspaceOptionsUpdateRequest(value: object): value is WorkspaceOptionsUpdateRequest {
    if (!('defaultAssignees' in value) || value['defaultAssignees'] === undefined) return false;
    if (!('defaultEmailNotification' in value) || value['defaultEmailNotification'] === undefined) return false;
    if (!('defaultEmailDelay' in value) || value['defaultEmailDelay'] === undefined) return false;
    if (!('defaultInactivityLimit' in value) || value['defaultInactivityLimit'] === undefined) return false;
    if (!('emailClientsAboutUnreadMessages' in value) || value['emailClientsAboutUnreadMessages'] === undefined) return false;
    return true;
}

export function WorkspaceOptionsUpdateRequestFromJSON(json: any): WorkspaceOptionsUpdateRequest {
    return WorkspaceOptionsUpdateRequestFromJSONTyped(json, false);
}

export function WorkspaceOptionsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceOptionsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultAssignees': json['defaultAssignees'],
        'defaultEmailNotification': json['defaultEmailNotification'],
        'defaultEmailDelay': json['defaultEmailDelay'],
        'defaultInactivityLimit': json['defaultInactivityLimit'],
        'emailClientsAboutUnreadMessages': json['emailClientsAboutUnreadMessages'],
    };
}

export function WorkspaceOptionsUpdateRequestToJSON(json: any): WorkspaceOptionsUpdateRequest {
    return WorkspaceOptionsUpdateRequestToJSONTyped(json, false);
}

export function WorkspaceOptionsUpdateRequestToJSONTyped(value?: WorkspaceOptionsUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defaultAssignees': value['defaultAssignees'],
        'defaultEmailNotification': value['defaultEmailNotification'],
        'defaultEmailDelay': value['defaultEmailDelay'],
        'defaultInactivityLimit': value['defaultInactivityLimit'],
        'emailClientsAboutUnreadMessages': value['emailClientsAboutUnreadMessages'],
    };
}

